import TaxonomyModal from './TaxonomyModal';

export default TaxonomyModal;
